import DenyDialog from './DenyDialog';

export default { 
  name: "deny", 
  component: DenyDialog, 
  fullScreen: false
};